import { DealCardSkeleton, Theme } from '@pelando/components';
import styled from 'styled-components';

export const ProfileDealCardSkeleton = styled(DealCardSkeleton)`
  background-color: rgb(${Theme.colors.Juliet});
`;
